import axios from '@/utils/api'

const state = {}

const getters = {}

const actions = {
  async criarGleba ({ commit }, dados) {
    await axios({
      method: 'post',
      data: dados,
      url: `gleba/salvar`
    })
  },
  async editarGleba ({ commit }, {gleba, id}) {
    await axios({
      method: 'put',
      data: gleba,
      url: `gleba/${id}`
    })
  },
  async buscarGleba ({ commit }, id) {
    return axios({
      method: 'get',
      url: `gleba/${id}`
    })
  },
  async listar ({ commit }, dados) {
    return axios({
      method: 'post',
      data: dados,
      url: `gleba/listar`
    })
  },
  async remover ({ commit }, id) {
    return axios({
      method: 'DELETE',
      url: `gleba/${id}`
    })
  },
  async buscarGlebaByMunicipio ({ commit }, ids) {
    const queryParams = ids.map(id => `ids=${encodeURIComponent(id)}`).join('&')
    return axios({
      method: 'get',
      url: `gleba/por-municipios?${queryParams}`
    })
  },
  async getCsv ({ commit }, filtro) {
    await axios({
      method: 'POST',
      url: 'gleba/gerar/csv',
      data: filtro,
      responseType: 'blob'
    })
  },
  async getProcessoCsv ({ commit }, id) {
    await axios({
      method: 'POST',
      url: `gleba/gerar/csv/${id}/processo`,
      responseType: 'blob'
    })
  },
  async hasProcessoVinculado ({ commit }, id) {
    return axios({
      method: 'GET',
      url: `gleba/verifica/vinculo/processo/${id}`
    })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/gleba.js